import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '@/features/auth/providers/AuthProvider';
import { Spinner } from '@/components/ui/base/Spinner';

const PublicGuard = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isInitializing } = useAuthContext();
  const location = useLocation();
  const from = (location.state as { from?: string })?.from || '/';

  if (isInitializing) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};

export default PublicGuard;
